<template lang="pug">
	.login-form
		h2.title Login

		.row
			p.subtitle Email
			input(v-model='email' type='text' @keydown.enter='submit')

		.row
			p.subtitle Password
			input(v-model='password' type='password' @keydown.enter='submit')

		//- a.forgot(@click='emitForgot') Forgot email or need to create password?
		.forgot
			span
				| Forgot&nbsp;
				a(@click='emitForgot( 2 )') email
				| &nbsp;or&nbsp;
				a(@click='emitForgot') password
				| ?

		.popup-error(:class='errorState')
			p {{ this.error }}

		.submit-wrapper
			a.button(:class='submittedState' @click='submit') Submit
				//- custom element, completely optional if you want to keep. CSS is in login.vue
				.check-mark
</template>

<script>
import { SignIn, GetUser } from '@/lib/db/auth';

export default {
	name : 'login-form',

	props : {
		user : {
			type     : Object,
			required : true,
		},
		forgot : {
			type    : Boolean,
			default : false,
		}
	},

	data : () => ( {
		email    : null,
		password : null,

		error      : '',
		errorState : 'hidden',

		submittedState : 'not-submitted',
	} ),

	watch : {
		email() {
			this.error = '';
			this.errorState = 'hidden';
		},

		password() {
			this.error = '';
			this.errorState = 'hidden';
		}
	},

	methods : {
		emitForgot( slide ) {

			if ( typeof slide === 'number' ) {
				this.$emit( 'forgot', slide );
				return;
			}

			this.$emit( 'forgot', 1 );

		},

		showError( message ) {
			this.error      = message;
			this.errorState = 'active';
		},

		submit() {

			if ( this.email === ( null || undefined ) || this.password === ( null || undefined ) ) {
				this.showError( 'Check if both fields are entered correctly.' );
			}

			else if ( this.email === '' || this.password === '' ) {
				this.showError( 'Check if both fields are entered correctly.' );
			}

			SignIn( this.email, this.password )
				.then( () => GetUser() )
				.then( ( user ) => {


					// console.log( 'user from login form ', user );
					const newUser = {
						name  : user.displayName,
						email : user.email,
						uid   : user.uid,
					};

					if ( newUser.name === null ) {
						newUser.name = '';
					}

					this.submittedState = 'submitted';

					this.$store.dispatch( 'login', newUser );

					setTimeout( () => {
						this.$router.push( '/app/home' );
					}, 1500 );

				} )
				.catch( ( error ) => {
					// Handle Errors here.
					// eslint-disable-next-line no-unused-vars
					const errorCode    = error.code;
					const errorMessage = error.message;

					this.showError( errorMessage );
					// ...
				} );

		},
	},
};
</script>

<style lang='scss'>
@import '@/assets/scss/_variables.scss';

.login-form {
	display: flex;
	flex-flow: column;
	justify-content: center;
	padding: 20px;

	>* {
		margin: 8px 0;
	}

	.title {
		color: $color-primary;
		font-size: 36px;
		text-align: left;
		margin: 0 0 0 25px;
	}

	.row {
		.subtitle {
			color: $blueGrey;
			font-size: 16px;
			text-align: left;
			padding: 10px 20px 10px 10px;
		}
	}

	.forgot {
		color: $grey;
		padding: 0 60px;
	}

	.forgot:hover, .button:hover {
		cursor: pointer;
	}
}

@media ( max-width : $tablet ) {
	.login-form {
		padding: 0px;
		padding-bottom: 50px;
	}
}
</style>
